import { useDebounceFunction } from '@hooks/useDebounceFunction';
import { getObject, saveObject } from '@utils/localStorage';
import { useEffect } from 'react';

import { mergeByVersion } from './mergeByVersion';
import { type UsePersistDataOnStoreProps, type WhitVersion } from './types';

const usePersistDataOnStore = <TData extends WhitVersion>({
  data,
  initialData,
  initializeData,
  key,
  delay = 500,
}: UsePersistDataOnStoreProps<TData>) => {
  const debouncedSaveObject = useDebounceFunction((data: TData) => {
    saveObject(key, data);
  }, delay);

  useEffect(() => {
    debouncedSaveObject(data);
  }, [debouncedSaveObject, data]);

  useEffect(() => {
    const storeData = getObject<TData>(key) ?? initialData;

    const newData = mergeByVersion(initialData, storeData);

    initializeData(newData);
  }, [initialData, initializeData, key]);
};

export { usePersistDataOnStore };
